import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteAssessmentFeedbackMutation, deleteAssessmentFeedbackMutationVariables } from '../generated/deleteAssessmentFeedbackMutation';
import { assessmentFeedbackFieldsFragment } from '../models/AssessmentFeedback';

/**
 * Get a callback to delete a AssessmentFeedback in the store.
 */
export function useDeleteAssessmentFeedbackCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteAssessmentFeedbackMutation, deleteAssessmentFeedbackMutationVariables>(
        gql`
            mutation deleteAssessmentFeedbackMutation ($id: ID!) {
                deleteAssessmentFeedback(id: $id) {
                    ...assessmentFeedbackFields
                }
            }

            ${assessmentFeedbackFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
